import { render, staticRenderFns } from "./CardService.vue?vue&type=template&id=000ec8ab&scoped=true&"
import script from "./CardService.vue?vue&type=script&lang=js&"
export * from "./CardService.vue?vue&type=script&lang=js&"
import style0 from "./CardService.vue?vue&type=style&index=0&id=000ec8ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000ec8ab",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
